import { FunctionComponent } from "react"
import { Button } from "@chakra-ui/react"
import { onCreateFileExample } from "@/modules/FakeRp/utils/createFile"

interface IExampleFileProps {
  fileFormater: string
  title?: string
}

export const Example: FunctionComponent<IExampleFileProps> = ({
  fileFormater,
  title
}) => {
  const handleExampleFileClick = () => {
    onCreateFileExample({
      formater: fileFormater,
      title: title || 'Arquivo_Exemplo'
    })
  }

  return (
    <Button 
      size="md"
      colorScheme="blue"
      onClick={handleExampleFileClick}
    >
      Arquivo Exemplo
    </Button>
  )
}